import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import FilterUIHelpers from "./filteruihelpers.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const colorFilter = document.getElementById('colorFilter');
const mobileFilterDropDown = document.getElementById('filterDropDown');

class ColorSelectorFilter {
    constructor() {
        this.action = this.action.bind(this);
        this.keyAction = this.keyAction.bind(this);
    }

    action(e) {
        e.preventDefault();

        var element = e.currentTarget;

        if (element.getAttribute('aria-selected') !== 'true') {
            this.add(element, true);
        } else {
            this.remove(element);
        }

        if (mobileFilterDropDown.classList.contains('active')) {
            mobileFilterDropDown.click();
        }

        UpdateFilterUrl.update(FilterValues, prodListValues, false);
    };


    keyAction(e) {
        if (e.which === 13) {
            this.action(e);
        }
    };

    update(element) {
        this.add(element, false);
    };

    updateCounts(filterOptions) {
        if (document.getElementById('colorFilter')) {
            const filters = colorFilter.getElementsByClassName('filterColorBlock');
            let filterId, optionCnt;

            for (let i = 0; i < filters.length; i++) {
                filterId = FilterValues.getFilterId(filters[i].id);
                optionCnt = 0;

                if (filterId && filterOptions) {
                    for (let j = 0; j < filterOptions.length; j++) {
                        if (filterOptions[j].Id === filterId) {
                            optionCnt = filterOptions[j].Count;
                            break;
                        }
                    }
                }

                FilterUIHelpers.getUpdatedFilterCount(document.getElementById(filters[i].id + '_label'), optionCnt);
                filters[i].title = filters[i].getAttribute('data-filter') + ' (' + optionCnt + ')';
            }
        }
    };

    add(element, logFilter) {
        element.setAttribute('aria-selected', 'true');
        element.querySelector('.svgWrapper').classList.remove('hide');
        element.querySelector('.svgWrapper').classList.add('show');
        FilterValues.addFilter(element.id, logFilter);
        SelectedFilters.addToSelectedFilter(element);
    };

    remove(element) {
        element.setAttribute('aria-selected', 'false');
        element.querySelector('.svgWrapper').classList.remove('show');
        element.querySelector('.svgWrapper').classList.add('hide');
        FilterValues.removeFilter(element.id);
        SelectedFilters.removeFromSelectedFilter(element);
    };

    clear(list) {
        for (var i = 0; i < list.length; i++) {
            this.remove(document.getElementById(list[i]));
        }
    };

    events() {
        if (colorFilter) {
            Array.prototype.forEach.call(colorFilter.querySelectorAll('button.filterColorBlock'), (element) => {
                element.removeEventListener('click', this.action);
                element.addEventListener('click', this.action);
                element.removeEventListener('keydown', this.keyAction);
                element.addEventListener('keydown', this.keyAction);
            });
        }
    };
}

export default new ColorSelectorFilter();